module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "kbx-progress",
    style: (_vm.getStyle()),
    attrs: {
      "klickbox-edit-item": "progress-bar-default",
      "klickbox-edit-item-dad": "progress",
      "klickbox-edit-label": _vm.$t('edit.canvas.default_item')
    }
  }, [_c('item-done'), _vm._v(" "), _c('item-active')], 1)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-9e418b46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/progressbar/percent/Items.vue
 ** module id = 890
 ** module chunks = 1
 **/